import React, { useState } from 'react';
import { Modal, Button, Upload, Input, message, Select, notification } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { importAddon, showAvailableAddonDetail } from '@/apis/addons';
import { useOne } from '@/hooks';
import { useInvalidate } from "@refinedev/core";

import { RESOURCE_TYPE_ADDONS } from '@/resources-def';

const { TextArea } = Input;

export const ImportAddon = ({visible, setVisible}) => {
  const [fileContent, setFileContent] = useState(null);
  const [versions, setVersions] = useState([]);
  const [existedVersions, setExistedVersions] = useState([]);
  const invalidate = useInvalidate();

  const beforeUpload = (file) => {

    const reader = new FileReader();
    reader.onload = async (e) => {
      const contentObj = JSON.parse(e.target.result);
      setFileContent(contentObj);
      let needConfig = true;
      if(contentObj.id) {
        const data = await showAvailableAddonDetail(contentObj.id);
        if(data?.value?.versions) {
          needConfig = false;
          setVersions(contentObj?.versions.map(item => item.version)); 
          setExistedVersions(data.value.versions.map(version => version.version));
        }
      }
      if(needConfig)
        setVersions(contentObj?.versions.map(item => item.version)); 
    };
    reader.onerror = () => {
      message.error('Read file failed');
    };
    reader.readAsText(file);
    return false; 
  };
  
  const versionsChange = (values) => {
    setVersions(values);
  }

  const handleImport = async () => {
    if (!fileContent) {
      return;
    }
    const formData = new FormData();
    const content = JSON.stringify({...fileContent, versions: fileContent.versions.filter((version) => versions.indexOf(version.version) != -1)});
    const blob = new Blob([content], { type: 'application/json' })
    formData.append('fileupload', blob, 'upload.json');
    const response = await importAddon(formData);
    clear();
    setVisible(false);
    if (response.status === "OK") {
      invalidate({
        resource: RESOURCE_TYPE_ADDONS,
        invalidates: ["list"],
      });
      notification.success({
        description: `Success to import Addon ${response.name}`,
      });
    } else {
      notification.error({
        description: `Failed to import Addon ${response.message}`,
      });
    }
  }

  const clear = () => {
    setFileContent(null);
    setExistedVersions([]);
    setVersions([]);
  }

  return (
    <>
      <Modal
        title="Import Add-on"
        visible={visible}
        onOk={handleImport}
        onCancel={() => {setVisible(false); clear();}}
        okText="Import"
        width={800}
        styles={{
          body: {
            height: '70vh',
            display: 'flex',
            flexDirection: 'column',
            gap: 16,
            padding: 24
          }
        }}
      >
        <div style={{ display: 'flex', gap: 8, justifyContent: 'space-between' }}>
        <label style={{ marginRight: 16 }}>Add-on Definition</label>
          <Upload
            showUploadList={false}
            beforeUpload={beforeUpload}
            accept=".txt,.csv,.json,.xml,.log"
            itemRender={() => null}
          >
            <Button icon={<UploadOutlined />}>Browse ...</Button>
          </Upload>
        </div>

        <div style={{ flex: 1, minHeight: 100 }}>
          <TextArea
            value={fileContent != null ? JSON.stringify({...fileContent, versions: fileContent.versions.filter((version) => versions.indexOf(version.version) != -1)}, null, 2) : ""}
            placeholder="Addon Preview"
            readOnly
            style={{
              height: '100%',
              resize: 'none',
              fontFamily: 'monospace',
              whiteSpace: 'pre-wrap'
            }}
          />
        </div>
        <Input
          placeholder="Addon Name"
          value={fileContent?.name}
          readOnly={true}
        />
        <Select
          mode="multiple"
          value={versions}
          onChange={versionsChange}
          placeholder="Please select the addon"
          style={{ width: '100%' }}
        >
          {fileContent?.versions?.map((version) => (
            <Option key={version.version} value={version.version}>
              {existedVersions.some(item => item == version.version) ? version.version + " (existed)" : version.version }
            </Option>
          ))}
        </Select>
        
      </Modal>
    </>
  );
};